import MuiStepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useTranslation } from "react-i18next";

interface StepperProps {
  step: number;
}

const Stepper = ({ step }: StepperProps) => {
  const { t } = useTranslation();

  const steps = [t("shop.edit.globalInformation"), t("shop.edit.shopLayout")];

  return (
    <MuiStepper activeStep={step - 1}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};
export default Stepper;
